/**
 * Trạng thái vé điện tử
 */
export default {
// -- 1 vé mới
// -- 2 vé bị hủy
// -- 3 vé thay thế
// -- 5 vé điều chỉnh
// -- 7 vé đã bị thay thế 
// -- 8 vé đã bị điều chỉnh

    OriginalTicket: 1, 
    DeletedTicket: 2, 
    ReplaceTicket: 3, 
    AdjustTicket: 5,
    ReplacedTicket: 7,
    AdjustedTicket: 8,
};